import { useState } from 'react'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'

const escapeHtml = text =>
	`${text ?? ''}`.replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char])

export const useCompanyFilter = (updateFilters, companies = []) => {
	const { t } = useTranslation()
	const [selectedCompanyId, setSelectedCompanyId] = useState('')

	const handleCompanyFilter = () => {
		if (!companies.length) {
			Swal.fire({
				title: t('korekty.list.companyFilter.noCompaniesTitle'),
				text: t('korekty.list.companyFilter.noCompaniesText'),
				icon: 'info',
			})
			return
		}

		const optionsHtml = [
			`<option value="">${escapeHtml(t('korekty.list.companyFilter.allCompanies'))}</option>`,
			...companies.map(
				company => `
				<option value="${escapeHtml(company.id)}" ${selectedCompanyId === company.id ? 'selected' : ''}>
					${escapeHtml(company.name)}
				</option>
			`
			),
		].join('')

		Swal.fire({
			title: t('korekty.list.companyFilter.title'),
			html: `
				<div style="text-align: left;">
					<div style="margin-bottom: 10px">${t('korekty.list.companyFilter.prompt')}</div>
					<select id="company-filter-select" class="swal2-input" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;">
						${optionsHtml}
					</select>
				</div>
			`,
			showCancelButton: true,
			showDenyButton: true,
			confirmButtonText: t('korekty.list.companyFilter.apply'),
			denyButtonText: t('korekty.list.companyFilter.clear'),
			cancelButtonText: t('korekty.list.companyFilter.cancel'),
			customClass: {
				denyButton: 'swal2-deny',
			},
			preConfirm: () => document.getElementById('company-filter-select')?.value || '',
		}).then(result => {
			if (result.isDenied) {
				setSelectedCompanyId('')
				updateFilters({ companyId: null })
			} else if (result.isConfirmed) {
				const newCompanyId = result.value || ''
				setSelectedCompanyId(newCompanyId)
				updateFilters(newCompanyId ? { companyId: newCompanyId } : { companyId: null })
			}
		})
	}

	const getCompanyDisplay = () => {
		if (!selectedCompanyId) return ''
		const company = companies.find(item => item.id === selectedCompanyId)
		return company ? company.name : selectedCompanyId
	}

	return {
		selectedCompanyId,
		handleCompanyFilter,
		getCompanyDisplay,
	}
}
